import React from 'react';
import { Row, Col, Input, Label, Button, Card, CardBody, CardHeader, CardTitle } from 'reactstrap';

const PrivacyPolicy = () => {
  return (
    <div className="container">
      <Card style={{ width: '65vw', color: '#424242' }} className="container">
        <CardHeader>
          <CardTitle>
            <p style={{ textAlign: 'center', fontSize: '1.5rem', color: '#2c7be5' }}>Privacy Policy</p>

            <p style={{ fontSize: '1.2rem', color: '#2c7be5' }}>Last updated: 2026-07-09.</p>

            <Row>
              <Col>
                <p style={{ fontSize: '0.9rem' }}>
                  MergeCall, a product of mergeasy.com, Inc ("us", "we", or "our"), provides calling and
                  text-messaging services through the MergeCall web application at{' '}
                  <a href="https://call.mergeasy.com/">https://call.mergeasy.com/</a>, the MergeCall Chrome
                  extension, and the MergeCall mobile application (together, the "Services"). This page informs you
                  of our policies regarding the collection, use and disclosure of Personal Information we receive
                  from users of the Services.
                  <br />
                  We use your Personal Information only to provide and improve the Services. By using the Services,
                  you agree to the collection and use of information in accordance with this policy.
                </p>
              </Col>
            </Row>

            <p style={{ fontSize: '1.2rem', color: '#2c7be5' }}>Information Collection And Use</p>
            <Row>
              <Col>
                <p style={{ fontSize: '0.9rem' }}>
                  To provide the Services, we may collect and process the following types of information:
                </p>
                <ul style={{ fontSize: '0.9rem' }}>
                  <li>
                    <strong>Account information</strong> — your name, email address, and password (stored in
                    hashed form), collected when you create an account or sign in.
                  </li>
                  <li>
                    <strong>Contacts and phone numbers</strong> — contacts you add or import, and phone numbers you
                    call or message through the Services.
                  </li>
                  <li>
                    <strong>Communication content and records</strong> — text messages you send and receive, call
                    logs and call metadata (numbers, time, duration, status), voicemails, and notes you attach to
                    calls or contacts.
                  </li>
                  <li>
                    <strong>Availability status</strong> — whether your MergeCall application or extension is
                    currently connected, used only to route incoming calls to you.
                  </li>
                  <li>
                    <strong>Payment information</strong> — processed by our payment provider; we do not store full
                    card numbers.
                  </li>
                </ul>
              </Col>
            </Row>

            <Row>
              <Col>
                <p style={{ fontSize: '1.2rem', color: '#2c7be5' }}>The Chrome Extension</p>

                <p style={{ fontSize: '0.9rem' }}>
                  The MergeCall Chrome extension detects phone numbers on web pages you visit so it can offer
                  click-to-call and click-to-text buttons. This detection happens locally in your browser; page
                  content is <strong>not</strong> transmitted to our servers. A phone number is sent to our servers
                  only when you choose to call or message it.
                  <br />
                  The extension stores your sign-in session (email address and authentication token) in Chrome's
                  extension storage, and connects to our servers to keep your online/offline availability current
                  and to place and receive calls and messages. The extension does not collect your browsing
                  history and does not sell or share any data with third parties for advertising.
                </p>
              </Col>
            </Row>

            <Row>
              <Col>
                <p style={{ fontSize: '1.2rem', color: '#2c7be5' }}>Log Data</p>

                <p style={{ fontSize: '0.9rem' }}>
                  Like many service operators, we collect information that your browser or device sends whenever you
                  use the Services ("Log Data"). This Log Data may include information such as your Internet Protocol
                  ("IP") address, browser or device type and version, the pages or features of the Services that you
                  use, the time and date of your activity, and related diagnostic data used to operate and secure the
                  Services.
                </p>
              </Col>
            </Row>

            <Row>
              <Col>
                <p style={{ fontSize: '1.2rem', color: '#2c7be5' }}>How We Share Information</p>

                <p style={{ fontSize: '0.9rem' }}>
                  We share information only as needed to operate the Services:
                </p>
                <ul style={{ fontSize: '0.9rem' }}>
                  <li>
                    <strong>Twilio Inc.</strong> — our telephony carrier, which transmits calls and text messages
                    on our behalf.
                  </li>
                  <li>
                    <strong>Service providers</strong> — hosting, analytics, and payment providers that process data
                    only on our instructions.
                  </li>
                  <li>
                    <strong>Legal requirements</strong> — when required by law or to protect our rights and users.
                  </li>
                </ul>
                <p style={{ fontSize: '0.9rem' }}>
                  We do <strong>not</strong> sell your personal information, and we do not use it for third-party
                  advertising. Our use of information received from the Chrome extension complies with the{' '}
                  <a href="https://developer.chrome.com/docs/webstore/program-policies/limited-use/">
                    Chrome Web Store User Data Policy
                  </a>
                  , including its Limited Use requirements.
                </p>
              </Col>
            </Row>

            <Row>
              <Col>
                <p style={{ fontSize: '1.2rem', color: '#2c7be5' }}>Security and Data Retention</p>

                <p style={{ fontSize: '0.9rem' }}>
                  We retain your information while your account is active and as required for legal and accounting
                  purposes. Data is transmitted over encrypted connections (HTTPS/WSS) and stored with access
                  controls. The security of your Personal Information is important to us, but no method of
                  transmission over the Internet or method of electronic storage is 100% secure; while we strive to
                  use commercially acceptable means to protect your Personal Information, we cannot guarantee its
                  absolute security.
                </p>
              </Col>
            </Row>

            <Row>
              <Col>
                <p style={{ fontSize: '1.2rem', color: '#2c7be5' }}>Your Choices</p>

                <p style={{ fontSize: '0.9rem' }}>
                  You can access and update your contacts and account details in the application. You can set
                  yourself offline at any time to stop receiving incoming calls. You can uninstall the extension at
                  any time; signing out removes your session from the browser. You may request a copy or deletion of
                  your personal data by contacting us.
                </p>
              </Col>
            </Row>

            <Row>
              <Col>
                <p style={{ fontSize: '1.2rem', color: '#2c7be5' }}>Changes To This Privacy Policy</p>

                <p style={{ fontSize: '0.9rem' }}>
                  This Privacy Policy is effective as of 2026-07-09 and will remain in effect except with respect to
                  any changes in its provisions in the future, which will be in effect immediately after being posted
                  on this page.
                  <br />
                  We reserve the right to update or change our Privacy Policy at any time and you should check this
                  Privacy Policy periodically. If we make any material changes, we will notify you either through the
                  email address you have provided us, or by placing a prominent notice within the Services.
                </p>
              </Col>
            </Row>

            <Row>
              <Col>
                <p style={{ fontSize: '1.2rem', color: '#2c7be5' }}>Contact Us</p>

                <p style={{ fontSize: '0.9rem' }}>
-                  If you have any questions about this Privacy Policy, please{' '}
-                  <a href="https://call.mergeasy.com/contactus">contact us</a>.
                </p>
              </Col>
            </Row>
          </CardTitle>
        </CardHeader>

        <Row className=" justify-content-center">
          <Col md={{ size: 8 }}>
            <p style={{ textAlign: 'center', fontSize: '1.5rem', color: '#2c7be5' }}>
              Support <i class="material-icons">phone</i> +1 415-417-0410
            </p>
            <p style={{ textAlign: 'center' }}>© 2026 mergeasy.com, Inc C Corp</p>
            <p style={{ textAlign: 'center' }}>651 N Broad St Suite 201, Middletown, DE 19709, United States</p>
            <p style={{ textAlign: 'center' }}>325 Front St W, Toronto, ON M5V 2Y1, Canada</p>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default PrivacyPolicy;
